import { Component } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RefreshForecastUploadService } from 'src/app/services/refresh-forecast-upload.service';

@Component({
  selector: 'app-refresh-forecast-upload-organism',
  templateUrl: './refresh-forecast-upload-organism.component.html',
  styleUrls: ['./refresh-forecast-upload-organism.component.scss']
})
export class RefreshForecastUploadOrganismComponent {
  file: File | null = null;
  isDragging = false;
  isUploading = false;
  errorMessage = '';

  constructor(
    private snack: MatSnackBar,
    private refreshForecastUploadService: RefreshForecastUploadService
  ) { }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const selectedFile = input.files?.[0] || null;
    this.handleSelectedFile(selectedFile);
    input.value = '';
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    this.isDragging = false;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    this.isDragging = false;
    const droppedFile = event.dataTransfer?.files?.[0] || null;
    this.handleSelectedFile(droppedFile);
  }

  removeFile(): void {
    this.file = null;
    this.errorMessage = '';
  }

  uploadFile(): void {
    if (!this.file) {
      return;
    }

    this.isUploading = true;
    this.refreshForecastUploadService.uploadFile(this.file).subscribe(() => {
      this.isUploading = false;
      this.showSnackbar(`${this.file?.name} uploaded successfully.`);
      this.file = null;
      this.errorMessage = '';
    }, () => {
      this.isUploading = false;
      this.showSnackbar(`Failed to upload ${this.file?.name}.`);
    });
  }

  formatFileSize(size: number): string {
    const units = ['bytes', 'KB', 'MB', 'GB', 'TB'];
    let index = 0;
    let formattedSize = size;

    while (formattedSize >= 1024 && index < units.length - 1) {
      formattedSize /= 1024;
      index++;
    }

    return `${formattedSize.toFixed(0)} ${units[index]}`;
  }

  private handleSelectedFile(file: File | null): void {
    if (!file) {
      return;
    }

    if (!this.isCsvFile(file)) {
      this.file = null;
      this.errorMessage = 'Only CSV files are allowed.';
      this.showSnackbar(this.errorMessage);
      return;
    }

    this.file = file;
    this.errorMessage = '';
  }

  private isCsvFile(file: File): boolean {
    const fileName = file.name.toLowerCase();
    return fileName.endsWith('.csv') || file.type === 'text/csv' || file.type === 'application/vnd.ms-excel';
  }

  private showSnackbar(message: string): void {
    this.snack.open(message, 'close', {
      duration: 3500,
      horizontalPosition: 'center',
      verticalPosition: 'top'
    });
  }
}
